module.exports = __webpack_public_path__ + "static/media/lunbo3.b851ec43.png";